// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"9":"b7d113f6","54":"b5905a42","601":"379747ed","626":"a755fbd1","851":"4b4c99a7","926":"fac61e0a","948":"c6db6d8a"}[chunkId] + ".js";
};